import { h } from '@stencil/core';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { getData } from '../../../globals/http';
import { CARD_LIST_MAX_SIZE_VARIANT_MAP, VARIANTS } from './constants';
export class MenuCards {
  handleListChanged() {
    this.requestProductsFeed();
  }
  constructor() {
    this.requestProductsFeed = () => {
      if (isEmpty(this.commerceConnectorSettings)) {
        return;
      }
      const { options: { enableChannelSight, feedUrl }, } = this.commerceConnectorSettings;
      if (this.variant === VARIANTS.SMALL && enableChannelSight && feedUrl) {
        const ids = this.list
          .slice(0, CARD_LIST_MAX_SIZE_VARIANT_MAP[this.variant])
          .map((item) => item.id)
          .join(',');
        getData(false, `${feedUrl}&pid=${ids}`).then((res) => {
          this.productsFeed = res;
        });
      }
    };
    this.page = undefined;
    this.title = undefined;
    this.categoryId = undefined;
    this.list = undefined;
    this.hmcBanner = undefined;
    this.variant = VARIANTS.DEFAULT;
    this.viewOnLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.commerceConnectorSettings = undefined;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.productsFeed = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    this.requestProductsFeed();
  }
  render() {
    const hasHmc = !isEmpty(this.hmcBanner) && this.variant === VARIANTS.DEFAULT;
    const maxVariantSize = CARD_LIST_MAX_SIZE_VARIANT_MAP[this.variant];
    const maxListSize = hasHmc ? maxVariantSize - 1 : maxVariantSize;
    return (h("div", { class: "menu-cards" }, h("p", { class: "menu-cards__title" }, this.title), h("ul", { class: cn('menu-cards__list', `menu-cards__list--${this.variant}`) }, this.list.slice(0, maxListSize).map((item) => (h("li", { class: "menu-cards__item" }, h("pes-menu-card", { categoryId: this.categoryId, page: this.page, item: item, viewAllTemplate: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, variant: this.variant, productsFeed: this.productsFeed, commerceConnectorSettings: this.commerceConnectorSettings, breadcrumbs: this.breadcrumbs, storageName: this.storageName })))), hasHmc && (h("li", { class: "menu-cards__item" }, h("pes-hmc-banner", { sourceId: this.categoryId, labels: this.hmcBanner.labels, categoryName: this.hmcBanner.categoryName, categoryProductConfiguratorUrl: this.hmcBanner.categoryProductConfiguratorUrl, hasQuestionnaire: this.hmcBanner.hasQuestionnaire, questionnaireUrl: this.hmcBanner.questionnaireUrl, rangeTooltipUrl: this.hmcBanner.rangeTooltipUrl, selectorConfigUrl: this.hmcBanner.selectorConfigUrl, isExternalProductConfiguratorUrl: this.hmcBanner.isExternalProductConfiguratorUrl, hmcHost: this.hmcBanner.host, token: this.hmcBanner.token, channel: this.hmcBanner.channel, pageSource: this.hmcBanner.pageSource })))), h("slot", null)));
  }
  static get is() { return "pes-menu-cards"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["menu-cards.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["menu-cards.css"]
    };
  }
  static get properties() {
    return {
      "page": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PesPageType",
          "resolved": "\"\" | \"all-products\" | \"category\" | \"comparator\" | \"product\" | \"product-cart\" | \"range\" | \"subcategory\"",
          "references": {
            "PesPageType": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "page",
        "reflect": false
      },
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "category-id",
        "reflect": false
      },
      "list": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllCategoriesCategoryProduct[]",
          "resolved": "ProductsAllCategoriesCategoryProduct[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "hmcBanner": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "THMCBanner",
          "resolved": "{ sourceId?: string; parentCategoryId?: string; categoryName?: string; labels?: THMCBannerLabels; hasQuestionnaire?: boolean; categoryProductConfiguratorUrl?: string; questionnaireUrl?: string; rangeTooltipUrl?: string; selectorConfigUrl?: string; isExternalProductConfiguratorUrl?: boolean; pimId?: string; host?: string; token?: string; channel?: string; pageSource?: string; }",
          "references": {
            "THMCBanner": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TItemVariants",
          "resolved": "\"default\" | \"small\"",
          "references": {
            "TItemVariants": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "VARIANTS.DEFAULT"
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CommerceConnectorSettings",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "breadcrumbs array for saving in indexDB"
        }
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "productsFeed": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "list",
        "methodName": "handleListChanged"
      }];
  }
}
